import { render, staticRenderFns } from "./XR.vue?vue&type=template&id=e967cdd6"
import script from "./XR.vue?vue&type=script&lang=js"
export * from "./XR.vue?vue&type=script&lang=js"
import style0 from "./XR.vue?vue&type=style&index=0&id=e967cdd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports